import { render, staticRenderFns } from "./BannersEditar.vue?vue&type=template&id=26aa1ff4&"
import script from "./BannersEditar.vue?vue&type=script&lang=js&"
export * from "./BannersEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports